import { call, put, select, takeLatest } from 'redux-saga/effects';

import addOnsService from 'services/addOnsService';

import { getGroupId } from 'store/session/selectors';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import {
  addOnDetailsPage,
  deleteAddOn,
  entities,
  formulaEdit,
  types,
  updateAddOn,
  updateVariable,
} from './actions';
import { getAddOn, getAddOnId } from './reducer';

export default function* root() {
  yield takeLatest(types.FORMULA_COMPILE_REQUEST, watchCompileFormula);
  yield takeLatest(types.DELETE_ADD_ON_REQUEST, watchDeleteAddOn);
  yield takeLatest(types.UPDATE_ADD_ON_REQUEST, watchUpdateAddOn);
  yield takeLatest(types.FORMULA_UPDATE_REQUEST, watchUpdateFormula);
  yield takeLatest(types.UPDATE_VARIABLE_REQUEST, watchUpdateVariable);
}

export function* initAddOnDetailsPage({ match }) {
  try {
    yield put(addOnDetailsPage.init());
    const addOnId = match.params.addOnId;
    const addOn = yield call(addOnsService.get, addOnId);
    yield put(entities.receiveAddOn({ addOn }));
  } catch (error) {
    console.error('ERROR WHEN INITIATING ADD-ON DETAILS PAGE', error);
  }
}

function* watchCompileFormula(action) {
  const { formula } = action.payload;
  const supplierId = yield select(getGroupId);

  try {
    yield call(addOnsService.compilePricingFormula, {
      formula,
      supplierId,
    });
    yield put(formulaEdit.compileSuccess());
  } catch (error) {
    yield put(formulaEdit.compileError({ error: getErrorMessage(error) }));
  }
}

function* watchDeleteAddOn() {
  try {
    const addOn = yield select(getAddOn);
    const addOnId = addOn.id;
    yield call(addOnsService.delete, addOnId);
    history.push('/processes/add_ons');
    yield put(deleteAddOn.success());
  } catch (error) {
    yield put(deleteAddOn.error({ error: getErrorMessage(error) }));
  }
}

function* watchUpdateAddOn(action) {
  try {
    const { addOnId, data } = action.payload;
    const response = yield call(addOnsService.update, addOnId, data);
    yield put(updateAddOn.success({ addOn: response }));
  } catch (error) {
    yield put(updateAddOn.error(error));
  }
}

function* watchUpdateFormula(action) {
  try {
    const { formula, revertedFrom } = action.payload;
    const addOnId = yield select(getAddOnId);

    const nextFormula = yield call(
      addOnsService.updatePricingFormula,
      addOnId,
      formula,
      revertedFrom,
    );
    const addOn = yield call(addOnsService.get, addOnId);

    yield put(formulaEdit.updateSuccess({ formula: nextFormula }));
    yield put(entities.receiveAddOn({ addOn }));
  } catch (error) {
    yield put(formulaEdit.updateError({ error: getErrorMessage(error) }));
  }
}

function* watchUpdateVariable(action) {
  try {
    const { data, variableId } = action.payload;
    const response = yield call(addOnsService.updateVariable, variableId, data);
    yield put(updateVariable.success({ variable: response }));
  } catch (error) {
    yield put(updateAddOn.error(error));
  }
}
